module.exports = __webpack_public_path__ + "static/media/lineVerticalTeacher.1d806595.svg";